
import props from './props'
export default {
  name: 'SourceComponent',
  props,
  data() {
    return {
      value: '',
    }
  },
  mounted() {
    this.value = this.$config.domain + this.$route.fullPath
  },
}
